module.exports = __webpack_public_path__ + "img/md-heart.71240e0b.svg";